const contracts = require('../contracts.json');
const base = "https://app.byppay.com";
const landing = "https://byppay.com";
const contactus = "https://www.byppay.com/conviertete-en-beta-user/";
const faqs = "https://www.byppay.com/faq/";
let NFTx, contractByto, contractMarketplace, contractAMM;
// try {
//
//     // eslint-disable-next-line global-require
//     NFTx = require('../Smart Contract/build/contracts/NFTX.json');
// } catch (e) {
//     console.log(e);
// }
// try {
//     contractByto = {
//         address: contracts.byto.address,
//         abi: contracts.byto.abi
//     };
// } catch (e) {
//     console.log(e);
// }
// try {
//     contractMarketplace = {
//         address: contracts.marketplace.address,
//         abi: contracts.marketplace.abi
//     };
// } catch (e) {
//     console.log(e);
// }
// try {
//     contractAMM =  {
//         address: contracts.amm.address,
//         abi: contracts.amm.abi
//     };
// } catch (e) {
//     console.log(e);
// }

module.exports = {
    STRIPE_PUBLIC_KEY: "pk_test_51I6uGRAH1lmR0otDuX7uwauP35GR8b4GtHM4wLvSQl6LqGMosOdPwvA3rx7m8VgH6R8hjX8O4p6kepYwnbAcWCG800SUtX8lK8",
    BASE_URL: base,
    LANDING_BASE_URL: landing,
    CONTACT_URL: contactus,
    FAQS_URL: faqs,



    erc20address: "0x77734E0462014F6CD11dD96bb136f3a484e23B9f",
    LOCAL_URL: "127.0.0.1:8080",
    BLOCKCHAIN_URL: "https://blkexplorer1.telsius.alastria.io/transaction/",
    //BLOCKCHAIN_URL: "https://explorer.kabuto.sh/testnet/transaction/",
    TOKEN_NAME: "RES",
    MAX_MINIMUM_BONIFICATION: 100,
    LOGIN_SOCIAL: {
        FACEBOOK_ID: '284125336186585',
        GOOGLE_ID: '617549378300-6k01969b7joqn9rao39tgm61b080o5o5.apps.googleusercontent.com'

    },
    BYPPAY_IDENTIFIER: 3,
    FORWARD_IDENTIFIER: 2,
    PAYMENT_MODE: {
        CRYPTO: 1,
        STRIPE: 2,
        OUTSIDE: 3
    },
    INVOICE: {
        STATUS_TEMPORARY: -1,
        STATUS_PENDING: 0,
        STATUS_CREATED: 1,
        STATUS_PAYED: 2,
        STATUS_COMPENSATED: 3,
        TYPE_RECEIVED: 10,
        TYPE_SENT: 11,
        PAYMENT_PENDING: 100,
        PAYMENT_SENT: 101,
        PAYMENT_RECEIVED: 102,
        OUTSIDE_PAYMENT: 4,
        CHAT_CREATED: 5,
        CHAT_ACCEPTED: 10,
        CHAT_PAY_METHOD: 20,
        CHAT_BYPPAYED: 35,
        CHAT_BYPPAYED_ACCEPTED: 50,
        CHAT_CLOSED: 100,
    },

    EXCHANGE: {
        STATUS_PENDING: 0,
        STATUS_IN_PROCESS: 1,
        STATUS_ACCEPTED: 2,
        STATUS_PAYED: 3,
    },

    CHAT_MODE: {
        LEFT: 0,
        RIGHT: 1
    },
    OFFERS: {
        STATUS_PENDING: 0,
        STATUS_IN_PROCESS: 1,
        STATUS_ACCEPTED: 2,
        STATUS_PAYED: 3,
    },

    FACTORING: {
        STATUS_PENDING: 0,
        STATUS_CREATED: 1,
        STATUS_DISCARDED: -1,
        STATUS_ACCEPTED: 2,
        STATUS_REJECTED: -2,
        STATUS_PAYED: 3,
        STATUS_UNPAYED: -3
    },

    FACTORING_PAYMENT_METHODS: {
        OUTSIDE_PLATFORM: 0,
        CRYPTO: 1,
        OPEN_BANKING: 2
    },

    ACCEPTED_FACTORING: {
        PAYER: 0,
        RECEIVER: 1,
        CREATED: 2,
        ALL: 3
    },

    ROSSUM: {
        STATUS_UPLOADED: 0,
        STATUS_SCANNED: 1
    },

    USER: {
        ROLE_NONE: 0,
        ROLE_ADMIN: 1,
        ROLE_USER: 2,
        ROLE_FACTOR: 3
    },

    PROPOSAL: {
        STATUS_REQUESTED: 0,
        STATUS_ACCEPTED: 1,
        STATUS_REJECTED: 2,
        MISSED: 3,

        PAYMENT_PENDING: 0,
        PAYMENT_SENT: 1,
        PAYMENT_RECEIVED: 2,

        PAYMENT_TOKEN_PENDING: 3,
        PAYMENT_TOKEN_SENT: 4,
        PAYMENT_TOKEN_RECEIVED: 5
    },
    INVITE_METHOD: {
        MAIL: 1,
        WHATSAP: 2,
        SMS: 3,
        COLOM: 4
    },
    ERRORS: {
        ERROR_GENERIC: 499,
        ERROR_SAVING_INVOICE: 500,
        ERROR_LISTING_INVOICES: 501,
        ERROR_SAVING_FACTORING: 502,
        ERROR_UPDATING_FACTORING: 503,
        INVALID_STATUS_CHANGE: 504,
        ERROR_LISTING_FACTORINGS: 505,
        INVALID_STATUS_CHANGE_USER: 506,
        ERROR_PAYING_INVOICE: 507,
        INVALID_PAYER: 508,
        INVALID_INVOICE_STATUS: 509,
        ERROR_STATISTICS: 510,
        ERROR_EXISTING_INVOICE: 511,
        INVOICE_NOT_FOUND: 512,
        ERROR_SAVING_USER: 513,
        ERROR_SAME_CIF: 514,
        ERROR_SAME_MAIL: 515,
        ERROR_USER_NOT_CREATED: 516,
        ERROR_USER_NOT_FOUND: 517,
        ERROR_MISSING_FIELDS: 518,
        ERROR_WRONG_PASSWORD: 519,
        ERROR_MISSING_VALIDATION: 520,
        ERROR_INVOICE_SC: 550,
        ERROR_INVOICE_NOT_FOUND: 600,
        ERROR_USER_ALREADY_VALIDATED: 601,
        ERROR_GETTING_COMISSION: 602,
        ERROR_FACTORING_NOT_FOUND: 603,
        ERROR_FACTORING_SC: 604,
        ERROR_EXISTING_NUMBER_INVOICE: 605,
        ERROR_SAVING_PROPOSAL: 606,
        ERROR_GETTING_OFFERS: 607,
        OFFER_NOT_FOUND: 608,
        ERROR_GETTING_PROPOSALS: 609,
        PROPOSAL_NOT_FOUND: 610,
        ERROR_GETTING_INVOICE: 611,
        ERROR_CHANGING_LANGUAGE: 612,
        ERROR_INVOICE_NOT_EDITABLE: 613,
        ERROR_FILE_TOO_BIG: 614,
        ERROR_FILE_NOT_FOUND: 615,
        ERROR_SAVING_NOTIFICATION: 616,
        ERROR_GET_NOTIFICATIONS: 617,
        ERROR_ROLE: 618,
        ERROR_UPDATING_STRIPE: 619,
        ERROR_UPDATING_WALLET_ADDRESS: 620,
        ERROR_USER_NOT_IN_CHAT: 621,
        ERROR_NOT_PROGRESS_UPDATED: 622,
        ERROR_NOT_CHAT_FOUND: 623,
        ERROR_USER_NOT_MESSAGE_SENDER: 624,
        ERROR_GET_CHAT: 625,
        ERROR_USER_ALREADY_MEMBER: 626,
        ERROR_USER_ALREADY_INVITED: 627,
        ERROR_GETTING_INVITED_USERS: 628,
        ERROR_GETTING_MEMBER_USERS: 629,
        ERROR_ADDING_MEMBER_CHAT: 630,
        ERROR_CHAT_ARCHIVE: 631,
        ERROR_CHAT_UNARCHIVE: 632,
    },

    contractByto: contractByto,
    contractMarketplace: contractMarketplace,
    contractAMM: contractAMM,
    contractNFTx: NFTx,
};
